import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2 } from 'lucide-react';
import { purchaseNotifications } from '../data/constants';
export function PurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // First show after 6 seconds
    const initialTimer = setTimeout(() => setVisible(true), 6000);
    return () => clearTimeout(initialTimer);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    // Hide after 6 seconds, then show next after 10 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      const nextTimer = setTimeout(() => {
        setIndex(i => (i + 1) % purchaseNotifications.length);
        setVisible(true);
      }, 10000);
      return () => clearTimeout(nextTimer);
    }, 6000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  const current = purchaseNotifications[index];
  const minutesAgo = index * 7 % 30 + 2;
  return <AnimatePresence data-id="element-365">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 40,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 40,
      scale: 0.9
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-[60] max-w-[300px]" data-id="element-366">
          <div className="relative bg-black border-2 border-primary rounded-2xl shadow-[0_0_30px_rgba(74,222,128,0.45)] p-3 pr-8 flex items-center gap-3" data-id="element-367">
            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-1.5 right-1.5 text-zinc-500 hover:text-white transition-colors p-1" data-id="element-368">
              <X className="w-3.5 h-3.5" data-id="element-369" />
            </button>

            <div className="bg-primary/20 border border-primary/40 rounded-full p-2 shrink-0" data-id="element-370">
              <ShoppingBag className="w-5 h-5 text-primary" data-id="element-371" />
            </div>

            <div className="min-w-0 flex-1" data-id="element-372">
              <div className="flex items-center gap-1 mb-0.5" data-id="element-373">
                <CheckCircle2 className="w-3 h-3 text-primary shrink-0" data-id="element-374" />
                <span className="text-[10px] font-bold text-primary uppercase tracking-wide" data-id="element-375">
                  Compra verificada
                </span>
              </div>
              <p className="text-xs text-white leading-snug" data-id="element-376">
                <span className="font-bold" data-id="element-377">{current.name}</span> de{' '}
                <span className="font-bold" data-id="element-378">{current.city}</span> compró el{' '}
                <span className="text-primary font-bold" data-id="element-379">{current.plan}</span>
              </p>
              <p className="text-[10px] text-zinc-500 mt-0.5" data-id="element-380">
                hace {minutesAgo} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}